import * as yup from "yup";
import React, { useRef } from "react";
import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";

export type DrainFieldInstallationInspectionFormProps = {
  id: string;
  returnPath: string;
    title: string;
    applicationInspectionId?: number;
    applicationId?: number;
    values?: DrainFieldInstallationInspectionInput;
  action: "post" | "put";
};

export type DrainFieldInstallationInspectionInput = {
    drainfieldInstallationId: number;
    applicationId: number;
    applicationInspectionId: number;
    areaComplianceId: number;
    areaCompliance?: ComplianceOptions
    areaComment: string;
    area1: number;
    area2?: number;
    configuration: string;
    distributionComplianceId: number;
    distributionCompliance?: ComplianceOptions;
    distributionComment: string;
    distribution: string;
    numberOfDrainlinesComplianceId: number;
    numberOfDrainlinesCompliance?: ComplianceOptions;
    numberOfDrainlinesComment: string;
    numberOfDrainline1: number;
    numberOfDrainline2: number;
    drainlineSeparationComplianceId: number;
    drainlineSeparationCompliance?: ComplianceOptions;
    drainlineSeparationComment: string;
    drainlineSlopeComplianceId: number;
    drainlineSlopeCompliance?: ComplianceOptions;
    drainlineSlopeComment: string;
    depthOfCoverComplianceId: number;
    depthOfCoverCompliance?: ComplianceOptions;
    depthOfCoverComment: string;
    elevationComplianceId: number;
    elevationCompliance?: ComplianceOptions;
    elevationComment: string;
    elevation1: string;
    elevation2: number;
    systemLocationComplianceId: number;
    systemLocationCompliance?: ComplianceOptions;
    systemLocationComment: string;
    dosingPumpComplianceId: number;
    dosingPumpCompliance?: ComplianceOptions;
    dosingPumpComment: string;
    dosingPump: number;
    aggregateSizeComplianceId: number;
    aggregateSizeCompliance?: ComplianceOptions;
    aggregateSizeComment: string;
    aggregateExcessiveComplianceId: number;
    aggregateExcessiveCompliance?: ComplianceOptions;
    aggregateExcessiveComment: string;
    aggregateDepthComplianceId: number;
    aggregateDepthCompliance?: ComplianceOptions;
    aggregateDepthComment: string;
    // Drainfield Product fields
    drainfieldTypeComplianceId: number;
    drainfieldTypeCompliance?: ComplianceOptions;
    drainfieldTypeComment: string;
    drainfieldProductMakeId: number;
    drainfieldProductModelId: number;
    isDrainfield2Showable: boolean;
    // Second Drainfield fields
    drainfield2AreaComplianceId: number;
    drainfield2AreaCompliance?: ComplianceOptions;
    drainfield2AreaComment: string;
         drainfield2Area: number;
    drainfield2DistributionComplianceId: number;
    drainfield2DistributionCompliance?: ComplianceOptions;
    drainfield2DistributionComment: string;
    drainfield2DistributionBoxOrHeader: number;
    drainfield2NumberOfDrainlinesComplianceId: number;
    drainfield2NumberOfDrainlinesCompliance?: ComplianceOptions;
    drainfield2NumberOfDrainlinesComment: string;
    
    drainfield2NumberOfDrainline: number;
    drainfield2DrainlineSeparationComplianceId: number;
    drainfield2DrainlineSeparationCompliance?: ComplianceOptions;
    drainfield2DrainlineSeparationComment: string;
    drainfield2DrainlineSeparationBedOrTrench: number;
    drainfield2DrainlineSlopeComplianceId: number;
    drainfield2DrainlineSlopeCompliance?: ComplianceOptions;
    drainfield2DrainlineSlopeComment: string;
    drainfield2DepthOfCoverComplianceId: number;
    drainfield2DepthOfCoverCompliance?: ComplianceOptions;
    drainfield2DepthOfCoverComment: string;
    drainfield2ElevationComplianceId: number;
    drainfield2ElevationCompliance?: ComplianceOptions;
    drainfield2ElevationComment: string;
    drainfield2Elevation: number;
    drainfield2ElevationBenchmark: string;
    drainfield2SystemLocationComplianceId: number;
    drainfield2SystemLocationCompliance?: ComplianceOptions;
    drainfield2SystemLocationComment: string;
    drainfield2DosingPumpComplianceId: number;
    drainfield2DosingPumpCompliance?: ComplianceOptions;
    drainfield2DosingPumpComment: string;
    drainfield2DosingPump: number;
    drainfield2AggregateSizeComplianceId: number;
    drainfield2AggregateSizeCompliance?: ComplianceOptions;
    drainfield2AggregateSizeComment: string;
    drainfield2AggregateExcessiveComplianceId: number;
    drainfield2AggregateExcessiveCompliance?: ComplianceOptions;
    drainfield2AggregateExcessiveComment: string;
    drainfield2AggregateDepthComplianceId: number;
    drainfield2AggregateDepthCompliance?: ComplianceOptions;
    drainfield2AggregateDepthComment: string;
    // Second Drainfield Product fields
    drainfield2DrainfieldTypeComplianceId: number;
    drainfield2DrainfieldTypeCompliance?: ComplianceOptions;
    drainfield2DrainfieldTypeComment: string;
    drainfield2DrainfieldProductMakeId: number;
    drainfield2DrainfieldProductModelId: number;
    dateCreated: Date|string;
    createdBy: string;
    dateUpdated: Date;
    updatedBy: string;
    inspectionStatusId: number;
    distributionBoxOrHeader:string;
    elevationBenchmark: string
    drainlineSeparationBedOrTrench:string;
    markAll: number;
    numberOfUnits: number;
	drainfield2NumberOfUnits: number;
};
export type ComplianceData = {
    id: number;
    name: string;

};

export type DrainfieldProductMakeData = {
    id: string;
    name: string;
};

export type DrainfieldProductModelData = {
    id: string;
    name: string;
    makeId: number;
};


export const schema = yup.object().shape({
  
    areaComplianceId: yup
    .number()
    .min(1, "Drainfield Area Compliance is required")
        .required("Drainfield Area Compliance is required")
        .typeError("Drainfield Area Compliance is required"),
   
    area1:
    yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
    .when("areaComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
      .min(1, "Drainfield Area 1 is required")
    .required("Drainfield Area 1 is required")
    .typeError("Drainfield Area 1 should be numeric")
}),

    area2:
    yup.number().nullable(true)
      .min(1,"Drainfield Area 2 should be numeric")
    .typeError("Drainfield Area 2 should be numeric")
    // .moreThan(0,"Drainfield Area 2 should be numeric &")
    .transform((value) => Number.isNaN(value)?null:value),
   
    numberOfDrainline1:
        yup.number()
        .transform((value) => Number.isNaN(value)?null:value).nullable()
        .when("area1",{
            is:(val:any) => typeof val ==  "number" && val > 0,
            then: 
            yup.number().nullable(true)
            .when("numberOfDrainlinesComplianceId", {
              is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
              then:yup.number()
            .min(1, "Numberofdrainline 1 is required")
            .required("Numberofdrainline 1 is required") 
            .typeError("Numberofdrainline 1 should be numeric"),})
                    }),
    numberOfDrainline2:
        yup.number()
        .transform((value) => Number.isNaN(value)?null:value).nullable()
        .when("area2",{
            is:(val:any) => typeof val ==  "number" && val > 0,
            then: 
            yup.number().nullable(true)
            .when("numberOfDrainlinesComplianceId", {
              is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
              then:yup.number()
            .min(1, "Numberofdrainline 2 is required")
            .required("Numberofdrainline 2 is required") 
            .typeError("Numberofdrainline 2 should be numeric"),
        }),
                    }),
//     area1: yup.string()
//     .when('area2', {
//       is: (val:any) => !val || val.length === 0,
//       then: yup.string().min(1, "Drainfield Area 1 is required").required("Drainfield Area 1 is required"),
//       otherwise: yup.string()
//     }),
//   area2: yup.string()
//     .when('area1', {
//       is: (email:any) => !email || email.length === 0,
//       then: yup.string().required("Drainfield Area 2 is required"),
//       otherwise: yup.string()
//     }),
    
//     numberOfDrainline1:
//         yup.number()
//         .transform((value) => Number.isNaN(value)?null:value).nullable()
//         .when("area1",{
//             is:(val:any) => val != null && val.length !== 0,
//             then: 
//             yup.number()
//             .min(1, "Numberofdrainline 1 is required")
//             .required("Numberofdrainline 1 is required") 
//             .typeError("Numberofdrainline 1 should be numeric"),
//                     }),
//     numberOfDrainline2:
//         yup.number()
//         .transform((value) => Number.isNaN(value)?null:value).nullable()
//         .when("area2",{
//             is:(val:any) => val != null && val.length !== 0,
//             then: 
//             yup.number()
//             .min(1, "Numberofdrainline 2 is required")
//             .required("Numberofdrainline 2 is required") 
//             .typeError("Numberofdrainline 2 should be numeric"),
//                     }),
    distributionComplianceId: yup
    .number()
    .min(1, "Distribution Box Compliance is required")
        .required("Distribution Box Compliance is required")
        .typeError("Distribution Box Compliance is required"),

    distributionBoxOrHeader: yup.number().nullable(true)
    .when("distributionComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
        .min(1, "Box or Header is required")
        .required("Box or Header is required")
        .typeError("Box or Header is required")
    }),
    ditributionComment: yup.string().nullable(true)
        .when("ditributionComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Distribution Comment is required")
                .typeError("Distribution Comment is required"),
        }),

    numberOfDrainlinesComplianceId: yup
        .number()
        .min(1, "Number of Drainlines Compliance is required")
        .required("Number of Drainlines Compliance is required")
        .typeError("Number of Drainlines Compliance is required"),

    numberOfDrainlinesComment: yup.string().nullable(true)
        .when("numberOfDrainlinesComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("NumberOfDrainlines Comment is required")
                .typeError("NumberOfDrainlines Comment is required"),
        }),

    drainlineSeparationComplianceId: yup
    .number()
        .min(1, "DrainlineSeparation Compliance is required")
        .required("DrainlineSeparation Compliance is required")
        .typeError("DrainlineSeparation Compliance is required"),
       
        drainlineSeparationBedOrTrench: yup.number().nullable(true)
    .when("drainlineSeparationComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
        .min(1, "Bed or Trench is required")
        .required("Bed or Trench is required")
        .typeError("Bed or Trench is required")
    }),
    drainlineSeparationComment: yup.string().nullable(true)
        .when("drainlineSeparationComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("DrainlineSeparation Comment is required")
                .typeError("DrainlineSeparation Comment is required"),
        }),

    drainlineSlopeComplianceId: yup
        .number()
        .min(1, "DrainlineSlope Compliance is required")
        .required("DrainlineSlope Compliance is required")
        .typeError("DrainlineSlope Compliance is required"),
    drainlineSlopeComment: yup.string().nullable(true)
        .when("drainlineSlopeComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("DrainlineSlope Comment is required")
                .typeError("DrainlineSlope Comment is required"),
        }),


    depthOfCoverComplianceId: yup
        .number()
        .min(1, "DepthOfCover Compliance is required")
        .required("DepthOfCover Compliance is required")
        .typeError("DepthOfCover Compliance is required"),
    depthOfCoverComment: yup.string().nullable(true)
        .when("depthOfCoverComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("DepthOfCover Comment is required")
                .typeError("DepthOfCover Comment is required"),
        }),


    elevationComplianceId: yup
        .number()
        .min(1, "Elevation Compliance is required")
        .required("Elevation Compliance is required")
        .typeError("Elevation Compliance is required"),
    elevation1: yup.number().nullable(true) .transform((value) => Number.isNaN(value)?null:value).nullable()
    .when("elevationComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
    .min(0, "Elevation (inches) is required")
    .required("Elevation (inches) is required") 
    .typeError("Elevation (inches) should be numeric"),
    }),
    elevationBenchmark: yup.number().nullable(true)
    .when("elevationComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
    .min(1, "Above or below benchmark is required")
        .required("Above or below benchmark is required")
        .typeError("Above or below benchmark is required"),
    }),
    elevationComment: yup.string().nullable(true)
        .when("elevationComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Elevation Comment is required")
                .typeError("Elevation Comment is required"),
        }),


    systemLocationComplianceId: yup
        .number()
        .min(1, "Drainfield Location Compliance is required")
        .required("Drainfield Location Compliance is required")
        .typeError("Drainfield Location Compliance is required"),
    systemLocationComment: yup.string().nullable(true)
        .when("systemLocationComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("System Location Comment is required")
                .typeError("System Location Comment is required"),
        }),


    dosingPumpComplianceId: yup
    .number()
        .min(1, "DosingPump Compliance is required")
        .required("DosingPump Compliance is required")
        .typeError("DosingPump Compliance is required"),
    dosingPump:yup.number().nullable(true) .transform((value) => Number.isNaN(value)?null:value).nullable()
     .when("dosingPumpComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
        then: yup.number()
        .min(1, "Number of Dosing Pumps is required")
        .required("Number of Dosing Pumps is required") 
        .typeError("Number of Dosing Pumps should be numeric"),
     }),
     
    dosingPumpComment: yup.string().nullable(true)
        .when("dosingPumpComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Dosing Pump Comment is required")
                .typeError("Dosing Pump Comment is required"),
        }),


    aggregateSizeComplianceId: yup
        .number()
        .min(1, "AggregateSize Compliance is required")
        .required("AggregateSize Compliance is required")
        .typeError("AggregateSize Compliance is required"),
    aggregateSizeComment: yup.string().nullable(true)
        .when("aggregateSizeComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Aggregate Size Comment is required")
                .typeError("Aggregate Size Comment is required"),
        }),


    aggregateExcessiveComplianceId: yup
        .number()
        .min(1, "AggregateExcessive Compliance is required")
        .required("AggregateExcessive Compliance is required")
        .typeError("AggregateExcessive Compliance is required"),
    aggregateExcessiveComment: yup.string().nullable(true)
        .when("aggregateExcessiveComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Drainfield Excessive Comment is required")
                .typeError("Drainfield Excessive Comment is required"),
        }),


    aggregateDepthComplianceId: yup
        .number()
        .min(1, "AggregateDepth Compliance is required")
        .required("AggregateDepth Compliance is required")
        .typeError("AggregateDepth Compliance is required"),
    aggregateDepthComment: yup.string().nullable(true)
        .when("aggregateDepthComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Aggregate Depth Comment is required")
                .typeError("Aggregate Depth Comment is required"),
        }),



    // Second Drainfield validation schema
    drainfield2AreaComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Area Compliance is required")
                .required("Drainfield 2 Area Compliance is required")
                .typeError("Drainfield 2 Area Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2Area: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
        .when(['isDrainfield2Showable', 'drainfield2AreaComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2AreaComplianceId: number) => 
                isDrainfield2Showable && drainfield2AreaComplianceId != Constants.Not_Applicable && drainfield2AreaComplianceId != Constants.Unobserved,
            then: yup.number()
                .min(1, "Drainfield 2 Area is required")
                .required("Drainfield 2 Area is required")
                .typeError("Drainfield 2 Area should be numeric"),
            otherwise: yup.number().nullable().notRequired()
        }),

    

    drainfield2AreaComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2AreaComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2AreaComplianceId: number) => 
                isDrainfield2Showable && drainfield2AreaComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Area Comment is required")
                .typeError("Drainfield 2 Area Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2DistributionComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Distribution Box Compliance is required")
                .required("Drainfield 2 Distribution Box Compliance is required")
                .typeError("Drainfield 2 Distribution Box Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DistributionBoxOrHeader: yup.number().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DistributionComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DistributionComplianceId: number) => 
                isDrainfield2Showable && drainfield2DistributionComplianceId != Constants.Not_Applicable && drainfield2DistributionComplianceId != Constants.Unobserved,
            then: yup.number()
                .min(1, "Drainfield 2 Box or Header is required")
                .required("Drainfield 2 Box or Header is required")
                .typeError("Drainfield 2 Box or Header is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DistributionComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DistributionComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DistributionComplianceId: number) => 
                isDrainfield2Showable && drainfield2DistributionComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Distribution Comment is required")
                .typeError("Drainfield 2 Distribution Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2NumberOfDrainlinesComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Number of Drainlines Compliance is required")
                .required("Drainfield 2 Number of Drainlines Compliance is required")
                .typeError("Drainfield 2 Number of Drainlines Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    

    drainfield2NumberOfDrainline: yup.number()
        .transform((value) => Number.isNaN(value)?null:value).nullable()
        .when('isDrainfield2Showable', {
            is: true,
            then: yup.number().nullable(true)
                .when("drainfield2NumberOfDrainlinesComplianceId", {
                    is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
                    then: yup.number()
                        .min(1, "Drainfield 2 Number of drainlines is required")
                        .required("Drainfield 2 Number of drainlines is required")
                        .typeError("Drainfield 2 Number of drainlines should be numeric"),
                }),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2NumberOfDrainlinesComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2NumberOfDrainlinesComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2NumberOfDrainlinesComplianceId: number) => 
                isDrainfield2Showable && drainfield2NumberOfDrainlinesComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Number of Drainlines Comment is required")
                .typeError("Drainfield 2 Number of Drainlines Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2DrainlineSeparationComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Drainline Separation Compliance is required")
                .required("Drainfield 2 Drainline Separation Compliance is required")
                .typeError("Drainfield 2 Drainline Separation Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DrainlineSeparationBedOrTrench: yup.number().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DrainlineSeparationComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DrainlineSeparationComplianceId: number) => 
                isDrainfield2Showable && drainfield2DrainlineSeparationComplianceId != Constants.Not_Applicable && drainfield2DrainlineSeparationComplianceId != Constants.Unobserved,
            then: yup.number()
                .min(1, "Drainfield 2 Bed or Trench is required")
                .required("Drainfield 2 Bed or Trench is required")
                .typeError("Drainfield 2 Bed or Trench is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DrainlineSeparationComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DrainlineSeparationComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DrainlineSeparationComplianceId: number) => 
                isDrainfield2Showable && drainfield2DrainlineSeparationComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Drainline Separation Comment is required")
                .typeError("Drainfield 2 Drainline Separation Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2DrainlineSlopeComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Drainline Slope Compliance is required")
                .required("Drainfield 2 Drainline Slope Compliance is required")
                .typeError("Drainfield 2 Drainline Slope Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DrainlineSlopeComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DrainlineSlopeComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DrainlineSlopeComplianceId: number) => 
                isDrainfield2Showable && drainfield2DrainlineSlopeComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Drainline Slope Comment is required")
                .typeError("Drainfield 2 Drainline Slope Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2DepthOfCoverComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Depth of Cover Compliance is required")
                .required("Drainfield 2 Depth of Cover Compliance is required")
                .typeError("Drainfield 2 Depth of Cover Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DepthOfCoverComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DepthOfCoverComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DepthOfCoverComplianceId: number) => 
                isDrainfield2Showable && drainfield2DepthOfCoverComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Depth of Cover Comment is required")
                .typeError("Drainfield 2 Depth of Cover Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2ElevationComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Elevation Compliance is required")
                .required("Drainfield 2 Elevation Compliance is required")
                .typeError("Drainfield 2 Elevation Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2Elevation: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value).nullable()
        .when(['isDrainfield2Showable', 'drainfield2ElevationComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2ElevationComplianceId: number) => 
                isDrainfield2Showable && drainfield2ElevationComplianceId != Constants.Not_Applicable && drainfield2ElevationComplianceId != Constants.Unobserved,
            then: yup.number()
                .min(0, "Drainfield 2 Elevation (inches) is required")
                .required("Drainfield 2 Elevation (inches) is required")
                .typeError("Drainfield 2 Elevation (inches) should be numeric"),
            otherwise: yup.number().nullable().notRequired()
        }),

    // no second elevation value for drainfield 2

    drainfield2ElevationBenchmark: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2ElevationComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2ElevationComplianceId: number) => 
                isDrainfield2Showable && drainfield2ElevationComplianceId != Constants.Not_Applicable && drainfield2ElevationComplianceId != Constants.Unobserved,
            then: yup.string()
                .min(1, "Drainfield 2 Above or below benchmark is required")
                .required("Drainfield 2 Above or below benchmark is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2ElevationComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2ElevationComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2ElevationComplianceId: number) => 
                isDrainfield2Showable && drainfield2ElevationComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Elevation Comment is required")
                .typeError("Drainfield 2 Elevation Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2SystemLocationComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Location Compliance is required")
                .required("Drainfield 2 Location Compliance is required")
                .typeError("Drainfield 2 Location Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2SystemLocationComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2SystemLocationComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2SystemLocationComplianceId: number) => 
                isDrainfield2Showable && drainfield2SystemLocationComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 System Location Comment is required")
                .typeError("Drainfield 2 System Location Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2DosingPumpComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Dosing Pump Compliance is required")
                .required("Drainfield 2 Dosing Pump Compliance is required")
                .typeError("Drainfield 2 Dosing Pump Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DosingPump: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value).nullable()
        .when(['isDrainfield2Showable', 'drainfield2DosingPumpComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DosingPumpComplianceId: number) => 
                isDrainfield2Showable && drainfield2DosingPumpComplianceId != Constants.Not_Applicable && drainfield2DosingPumpComplianceId != Constants.Unobserved,
            then: yup.number()
                .min(1, "Drainfield 2 Number of Dosing Pumps is required")
                .required("Drainfield 2 Number of Dosing Pumps is required")
                .typeError("Drainfield 2 Number of Dosing Pumps should be numeric"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DosingPumpComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DosingPumpComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DosingPumpComplianceId: number) => 
                isDrainfield2Showable && drainfield2DosingPumpComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Dosing Pump Comment is required")
                .typeError("Drainfield 2 Dosing Pump Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2AggregateSizeComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Aggregate Size Compliance is required")
                .required("Drainfield 2 Aggregate Size Compliance is required")
                .typeError("Drainfield 2 Aggregate Size Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2AggregateSizeComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2AggregateSizeComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2AggregateSizeComplianceId: number) => 
                isDrainfield2Showable && drainfield2AggregateSizeComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Aggregate Size Comment is required")
                .typeError("Drainfield 2 Aggregate Size Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2AggregateExcessiveComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Aggregate Excessive Compliance is required")
                .required("Drainfield 2 Aggregate Excessive Compliance is required")
                .typeError("Drainfield 2 Aggregate Excessive Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2AggregateExcessiveComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2AggregateExcessiveComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2AggregateExcessiveComplianceId: number) => 
                isDrainfield2Showable && drainfield2AggregateExcessiveComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Aggregate Excessive Comment is required")
                .typeError("Drainfield 2 Aggregate Excessive Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2AggregateDepthComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Aggregate Depth Compliance is required")
                .required("Drainfield 2 Aggregate Depth Compliance is required")
                .typeError("Drainfield 2 Aggregate Depth Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2AggregateDepthComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2AggregateDepthComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2AggregateDepthComplianceId: number) => 
                isDrainfield2Showable && drainfield2AggregateDepthComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Aggregate Depth Comment is required")
                .typeError("Drainfield 2 Aggregate Depth Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    // Drainfield Product validation schema
    drainfieldTypeComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield Type Compliance is required")
                .required("Drainfield Type Compliance is required")
                .typeError("Drainfield Type Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfieldTypeComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfieldTypeComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfieldTypeComplianceId: number) => 
                isDrainfield2Showable && drainfieldTypeComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield Type Comment is required")
                .typeError("Drainfield Type Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfieldProductMakeId: yup.number().nullable(true)
        .when(['drainfieldTypeComplianceId'], {
            is: (drainfieldTypeComplianceId: number) => 
                drainfieldTypeComplianceId != Constants.Not_Applicable && drainfieldTypeComplianceId != Constants.Unobserved,
            then: yup.number()
                .min(1, "Drainfield Product Make is required")
                .required("Drainfield Product Make is required")
                .typeError("Drainfield Product Make is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfieldProductModelId: yup.number().nullable(true)
        .when(['drainfieldTypeComplianceId', 'drainfieldProductMakeId'], {
            is: (drainfieldTypeComplianceId: number, drainfieldProductMakeId: number) => 
                drainfieldTypeComplianceId != Constants.Not_Applicable && drainfieldTypeComplianceId != Constants.Unobserved && Number(drainfieldProductMakeId) > 0,
            then: yup.number()
                .min(1, "Drainfield Product Model is required")
                .required("Drainfield Product Model is required")
                .typeError("Drainfield Product Model is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    // Second Drainfield Product validation schema
    drainfield2DrainfieldTypeComplianceId: yup.number().nullable(true)
        .when("isDrainfield2Showable", {
            is: true,
            then: yup.number()
                .min(1, "Drainfield 2 Type Compliance is required")
                .required("Drainfield 2 Type Compliance is required")
                .typeError("Drainfield 2 Type Compliance is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DrainfieldTypeComment: yup.string().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DrainfieldTypeComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DrainfieldTypeComplianceId: number) => 
                isDrainfield2Showable && drainfield2DrainfieldTypeComplianceId === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Drainfield 2 Type Comment is required")
                .typeError("Drainfield 2 Type Comment is required"),
            otherwise: yup.string().nullable().notRequired()
        }),

    drainfield2DrainfieldProductMakeId: yup.number().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DrainfieldTypeComplianceId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DrainfieldTypeComplianceId: number) => 
                isDrainfield2Showable && drainfield2DrainfieldTypeComplianceId != Constants.Not_Applicable && drainfield2DrainfieldTypeComplianceId != Constants.Unobserved,
            then: yup.number()
                .min(1, "Drainfield 2 Product Make is required")
                .required("Drainfield 2 Product Make is required")
                .typeError("Drainfield 2 Product Make is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

    drainfield2DrainfieldProductModelId: yup.number().nullable(true)
        .when(['isDrainfield2Showable', 'drainfield2DrainfieldTypeComplianceId', 'drainfield2DrainfieldProductMakeId'], {
            is: (isDrainfield2Showable: boolean, drainfield2DrainfieldTypeComplianceId: number, drainfield2DrainfieldProductMakeId: number) => 
                isDrainfield2Showable && drainfield2DrainfieldTypeComplianceId != Constants.Not_Applicable && drainfield2DrainfieldTypeComplianceId != Constants.Unobserved && Number(drainfield2DrainfieldProductMakeId) > 0,
            then: yup.number()
                .min(1, "Drainfield 2 Product Model is required")
                .required("Drainfield 2 Product Model is required")
                .typeError("Drainfield 2 Product Model is required"),
            otherwise: yup.number().nullable().notRequired()
        }),

	numberOfUnits: yup
		.number()
		.transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value))
		.nullable(true)
		.when(['numberOfDrainlinesComplianceId', 'area1'], {
			is: (numberOfDrainlinesComplianceId: number, area1: number) =>
				numberOfDrainlinesComplianceId !== Constants.Not_Applicable &&
				numberOfDrainlinesComplianceId !== Constants.Unobserved &&
				Number(area1) > 0,
			then: yup
				.number()
				.min(1, 'Number of Units is required')
				.required('Number of Units is required')
				.typeError('Number of Units is required'),
			otherwise: yup.number().nullable().notRequired(),
		}),

	// Drainfield 2 Number of Units validation updated
	drainfield2NumberOfUnits: yup
		.number()
		.transform((value) => (Number.isNaN(value) ? null : value))
		.nullable(true)
		.when(['isDrainfield2Showable', 'drainfield2NumberOfDrainlinesComplianceId', 'drainfield2Area'], {
			is: (isDrainfield2Showable: boolean, drainfield2NumberOfDrainlinesComplianceId: number, drainfield2Area: number) =>
				isDrainfield2Showable &&
				drainfield2NumberOfDrainlinesComplianceId != Constants.Not_Applicable &&
				drainfield2NumberOfDrainlinesComplianceId != Constants.Unobserved &&
				Number(drainfield2Area) > 0,
			then: yup
				.number()
				.min(1, 'Drainfield 2 Number of Units is required')
				.required('Drainfield 2 Number of Units is required')
				.typeError('Drainfield 2 Number of Units is required'),
			otherwise: yup.number().nullable().notRequired(),
		}),

	drainfield2NumberOfUnitsComment: yup
		.string()
		.nullable(true)
		.when(['isDrainfield2Showable', 'drainfield2NumberOfUnitsComplianceId'], {
			is: (isDrainfield2Showable: boolean, drainfield2NumberOfUnitsComplianceId: number) => isDrainfield2Showable && drainfield2NumberOfUnitsComplianceId === Constants.Out_of_Compliance,
			then: yup.string().required('Drainfield 2 Number of Units Comment is required').typeError('Drainfield 2 Number of Units Comment is required'),
			otherwise: yup.string().nullable().notRequired(),
		}),

});
